import React, { Component } from 'react'
import {
  Paper,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer
} from '@material-ui/core'
// import uuid from 'uuid/v4'
import InputGroup from '../../../../UI/Forms/InputGroup/InputGroup'
import { connect } from 'react-redux'
import Aux from '../../../../../hoc/Auxiliary/Auxiliary'
import * as actions from '../../../../../store/actions'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'

class GradeTable extends Component {
  state = {
    gradeData: [],
    data: [],
    adjustData: []
  }

  static getDerivedStateFromProps(props, state) {
    if (typeof props.adjustData && typeof props.adjustData !== 'undefined') {
      if (props.gradeData !== state.gradeData) {
        if (props.adjustData.force_rank_budget.length !== 0) {
          let data = props.adjustData.force_rank_budget
          let grade = props.gradeData.map((item, key) => {
            return {
              ...item,
              budget: +data[key].budget_percent,
              amount: +data[key].budget_emp,
              id: item.value_list_id ? item.value_list_id : item.grade_id
            }
          })

          props.grade(grade, props.total)

          return {
            gradeData: props.gradeData,
            data: grade,
            CountForceRank: props.total
          }
        } else {
          let data = props.gradeData
          let grade = data.map(item => {
            return {
              ...item,
              budget: 0,
              amount: 0,
              id: item.value_list_id ? item.value_list_id : item.grade_id
            }
          })

          props.grade(grade, props.total)

          return {
            gradeData: props.gradeData,
            data: grade,
            CountForceRank: props.total
          }
        }
      }
    }
    return null
  }

  componentDidMount() {
    if (this.props.adjustData.force_rank_budget.length !== 0) {
      let data = []
      this.state.data.map(item => {
        data.push(item.amount)
        return item
      })
      const param = {
        grade: data,
        amount_grade: this.state.CountForceRank,
        company_id: this.props.filterControls.company_id.value.value,
        form_id: this.props.filterControls.form_id.value.value,
        org_id: this.props.filterControls.org_id.value.value
      }
      this.props.fetchForceRankList(param)
    }
  }

  inputChanged = (key, id, e) => {
    let updateData = this.state.data.map(item => {
      if (item.id === id) {
        if (key === 'budget') {
          let amount = ~~(this.state.CountForceRank * ((parseInt(e.target.value) || 0) / 100))
          return {
            ...item,
            budget: parseInt(e.target.value) || 0,
            amount: amount,
            id: item.value_list_id ? item.value_list_id : item.grade_id
          }
        } else if (key === 'amount') {
          return {
            ...item,
            amount: parseInt(e.target.value) || 0,
            id: item.value_list_id ? item.value_list_id : item.grade_id
          }
        }
      } else {
        return item
      }
      return item
    })
    this.props.grade(updateData, this.state.CountForceRank)
    this.setState({
      data: updateData
    })
  }

  sumBudget = () => {
    let sum = 0
    this.state.data.map(item => {
      sum = sum + item.budget
      return item
    })
    return `${sum} (%)`
  }

  sumAmount = () => {
    let sum = 0
    this.state.data.map(item => {
      sum = sum + item.amount
      return item
    })

    return `${sum} (${this.state.CountForceRank ? this.state.CountForceRank : 0})`
  }

  render() {
    return (
      <Aux>
        <Paper>
          {this.state.data.length > 0 ? (
            <TableContainer>
              <Table stickyHeader size='small'>
                <TableHead>
                  <TableRow>
                    <TableCell align='center'>{this.props.translate('grade')}</TableCell>
                    <TableCell align='center'>{this.props.translate('budget')} (%)</TableCell>
                    <TableCell align='center'>{this.props.translate('amount')}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.data.map(row => (
                    <TableRow key={row.id}>
                      <TableCell align='center'>{row.value_list_name}</TableCell>
                      <TableCell align='center'>
                        <InputGroup
                          rows
                          inputType={'input'}
                          // configs={formWithOptions.elementConfig}
                          changed={e => this.inputChanged('budget', row.id, e)}
                          inputValue={row.budget}
                          configs={{ endAdornment: '%' }}
                        />
                      </TableCell>
                      <TableCell align='center'>
                        <InputGroup
                          inputType={'input'}
                          // configs={formWithOptions.elementConfig}
                          changed={e => this.inputChanged('amount', row.id, e)}
                          inputValue={row.amount}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                  <TableRow>
                    <TableCell align='center'>Total</TableCell>
                    <TableCell align='center'>{this.sumBudget()}</TableCell>
                    <TableCell align='center'>{this.sumAmount()}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          ) : null}
        </Paper>
      </Aux>
    )
  }
}

const mapStateToProps = state => {
  return {
    pagination: state.forceRank.pagination,
    total: state.forceRank.total,
    filters: state.forceRank.filter,
    filtered: state.forceRank.filtered,
    filterLoadingQueue: state.forceRank.filterLoadingQueue,
    filterData: state.forceRank.filterData,
    filterLoading: state.forceRank.filterLoading,
    gradeData: state.forceRank.gradeData,
    pageLoading: state.forceRank.filterLoading || state.forceRank.appraisalTypes.length === 0,
    filterOptions: {
      companyFilterOptions: state.forceRank.filterCompanies,
      formFilterOptions: state.forceRank.filterForms,
      orgFilterOptions: state.forceRank.filterOrgs
    }
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchForceRankList: param => dispatch(actions.fetchReStoreForceRankList(param))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(GradeTable))
